// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.assent-page {
  min-height: 100vh;
  background: #f8f9fb;
  padding: 48px 16px 80px;
  display: flex;
  justify-content: center;
}

.assent-wrap {
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}

/* Header */
.assent-header {
  text-align: center;
}

.assent-logo-mark {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background: #1a56db;
  color: #fff;
  font-weight: 700;
  font-size: 14px;
  letter-spacing: .04em;
  border-radius: 10px;
  margin-bottom: 20px;
}

.assent-title {
  font-size: 22px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 10px;
  line-height: 1.3;
}

.assent-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin: 0;
  line-height: 1.6;
  max-width: 560px;
  margin-inline: auto;
}

/* Document panels */
.assent-document {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  overflow: hidden;
}

.doc-section-header {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 14px 20px;
  border-bottom: 1px solid #e5e7eb;
  background: #f9fafb;
}

.doc-section-label {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: #374151;
}

.doc-section-version {
  font-size: 12px;
  color: #9ca3af;
}

.doc-scroll-area {
  max-height: 420px;
  overflow-y: auto;
  padding: 0 24px;
  border-bottom: 1px solid #e5e7eb;
  /* Subtle inner shadow to hint scrollability */
  background:
    linear-gradient(white 30%, rgba(255,255,255,0)) center top,
    linear-gradient(rgba(255,255,255,0), white 70%) center bottom,
    radial-gradient(farthest-side at 50% 0, rgba(0,0,0,.06), rgba(0,0,0,0)) center top,
    radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.06), rgba(0,0,0,0)) center bottom;
  background-repeat: no-repeat;
  background-size: 100% 40px, 100% 40px, 100% 12px, 100% 12px;
  background-attachment: local, local, scroll, scroll;
}

/* Legal document typography */
.legal-doc {
  padding: 20px 0 24px;
  color: #111827;
}

.legal-doc h2.doc-h1 {
  font-size: 13px;
  font-weight: 700;
  letter-spacing: .04em;
  text-transform: uppercase;
  color: #111827;
  margin: 24px 0 6px;
  padding-top: 4px;
  border-top: 1px solid #f3f4f6;
}

.legal-doc h2.doc-h1:first-of-type {
  margin-top: 12px;
}

.legal-doc h3.doc-h2 {
  font-size: 12px;
  font-weight: 700;
  color: #374151;
  margin: 14px 0 4px;
}

.legal-doc p {
  font-size: 13px;
  line-height: 1.65;
  color: #374151;
  margin-bottom: 8px;
}

.legal-doc ul.doc-list {
  font-size: 13px;
  line-height: 1.65;
  color: #374151;
  padding-left: 20px;
  margin-bottom: 8px;
}

.legal-doc ul.doc-list li {
  margin-bottom: 4px;
}

.legal-doc a {
  color: #1a56db;
}

/* Acceptance checkbox row */
.agreement-check {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 16px 20px;
  cursor: pointer;
  margin: 0;
}

.agreement-checkbox {
  margin-top: 2px;
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  accent-color: #1a56db;
  cursor: pointer;
}

.agreement-check-label {
  font-size: 13px;
  color: #374151;
  line-height: 1.5;
}

/* Actions */
.assent-actions {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding-bottom: 8px;
}

.assent-btn-accept {
  width: 100%;
  padding: 11px 20px;
  font-size: 15px;
  font-weight: 600;
}

.assent-btn-logout {
  font-size: 13px;
  color: #9ca3af;
  padding: 0;
}

.assent-btn-logout:hover {
  color: #374151;
}

/* Loading */
.assent-loading {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 80px;
}

.assent-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #e5e7eb;
  border-top-color: #1a56db;
  border-radius: 50%;
  animation: spin .7s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

@media (max-width: 480px) {
  .assent-page { padding: 24px 12px 60px; }
  .doc-scroll-area { max-height: 320px; }
  .doc-section-header { flex-direction: column; gap: 2px; }
}
`, "",{"version":3,"sources":["webpack://./src/app/components/agreement-assent/agreement-assent.component.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,WAAW;AACX;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,8CAA8C;EAC9C;;;;4FAI0F;EAC1F,4BAA4B;EAC5B,2DAA2D;EAC3D,mDAAmD;AACrD;;AAEA,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA;EACE,eAAe,uBAAuB,EAAE;EACxC,mBAAmB,iBAAiB,EAAE;EACtC,sBAAsB,sBAAsB,EAAE,QAAQ,EAAE;AAC1D","sourcesContent":[".assent-page {\n  min-height: 100vh;\n  background: #f8f9fb;\n  padding: 48px 16px 80px;\n  display: flex;\n  justify-content: center;\n}\n\n.assent-wrap {\n  width: 100%;\n  max-width: 720px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n}\n\n/* Header */\n.assent-header {\n  text-align: center;\n}\n\n.assent-logo-mark {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 48px;\n  height: 48px;\n  background: #1a56db;\n  color: #fff;\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: .04em;\n  border-radius: 10px;\n  margin-bottom: 20px;\n}\n\n.assent-title {\n  font-size: 22px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 10px;\n  line-height: 1.3;\n}\n\n.assent-subtitle {\n  font-size: 14px;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.6;\n  max-width: 560px;\n  margin-inline: auto;\n}\n\n/* Document panels */\n.assent-document {\n  background: #fff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.doc-section-header {\n  display: flex;\n  align-items: baseline;\n  gap: 12px;\n  padding: 14px 20px;\n  border-bottom: 1px solid #e5e7eb;\n  background: #f9fafb;\n}\n\n.doc-section-label {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: .08em;\n  text-transform: uppercase;\n  color: #374151;\n}\n\n.doc-section-version {\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.doc-scroll-area {\n  max-height: 420px;\n  overflow-y: auto;\n  padding: 0 24px;\n  border-bottom: 1px solid #e5e7eb;\n  /* Subtle inner shadow to hint scrollability */\n  background:\n    linear-gradient(white 30%, rgba(255,255,255,0)) center top,\n    linear-gradient(rgba(255,255,255,0), white 70%) center bottom,\n    radial-gradient(farthest-side at 50% 0, rgba(0,0,0,.06), rgba(0,0,0,0)) center top,\n    radial-gradient(farthest-side at 50% 100%, rgba(0,0,0,.06), rgba(0,0,0,0)) center bottom;\n  background-repeat: no-repeat;\n  background-size: 100% 40px, 100% 40px, 100% 12px, 100% 12px;\n  background-attachment: local, local, scroll, scroll;\n}\n\n/* Legal document typography */\n.legal-doc {\n  padding: 20px 0 24px;\n  color: #111827;\n}\n\n.legal-doc h2.doc-h1 {\n  font-size: 13px;\n  font-weight: 700;\n  letter-spacing: .04em;\n  text-transform: uppercase;\n  color: #111827;\n  margin: 24px 0 6px;\n  padding-top: 4px;\n  border-top: 1px solid #f3f4f6;\n}\n\n.legal-doc h2.doc-h1:first-of-type {\n  margin-top: 12px;\n}\n\n.legal-doc h3.doc-h2 {\n  font-size: 12px;\n  font-weight: 700;\n  color: #374151;\n  margin: 14px 0 4px;\n}\n\n.legal-doc p {\n  font-size: 13px;\n  line-height: 1.65;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.legal-doc ul.doc-list {\n  font-size: 13px;\n  line-height: 1.65;\n  color: #374151;\n  padding-left: 20px;\n  margin-bottom: 8px;\n}\n\n.legal-doc ul.doc-list li {\n  margin-bottom: 4px;\n}\n\n.legal-doc a {\n  color: #1a56db;\n}\n\n/* Acceptance checkbox row */\n.agreement-check {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  padding: 16px 20px;\n  cursor: pointer;\n  margin: 0;\n}\n\n.agreement-checkbox {\n  margin-top: 2px;\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  accent-color: #1a56db;\n  cursor: pointer;\n}\n\n.agreement-check-label {\n  font-size: 13px;\n  color: #374151;\n  line-height: 1.5;\n}\n\n/* Actions */\n.assent-actions {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding-bottom: 8px;\n}\n\n.assent-btn-accept {\n  width: 100%;\n  padding: 11px 20px;\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.assent-btn-logout {\n  font-size: 13px;\n  color: #9ca3af;\n  padding: 0;\n}\n\n.assent-btn-logout:hover {\n  color: #374151;\n}\n\n/* Loading */\n.assent-loading {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 80px;\n}\n\n.assent-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #e5e7eb;\n  border-top-color: #1a56db;\n  border-radius: 50%;\n  animation: spin .7s linear infinite;\n}\n\n@keyframes spin {\n  to { transform: rotate(360deg); }\n}\n\n@media (max-width: 480px) {\n  .assent-page { padding: 24px 12px 60px; }\n  .doc-scroll-area { max-height: 320px; }\n  .doc-section-header { flex-direction: column; gap: 2px; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
